import React from 'react';
import { CheckboxProps } from '@mui/material';
import ExpandIconCheckbox from './ExpandIconCheckbox';

export interface ExpandProps {
  expanded: boolean;
  onExpandChange: (a: boolean) => void;
}

export interface ExpandActionProps extends CheckboxProps, ExpandProps {
  Component?: React.ElementType;
}

const ExpandAction: React.FC<React.PropsWithChildren<ExpandActionProps>> = ({
  Component = ExpandIconCheckbox,
  expanded = false,
  onExpandChange,
  ...other
}) => {
  const handleExpandChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onExpandChange(e.target.checked);
  };

  return <Component size="small" color="primary" checked={expanded} onChange={handleExpandChange} {...other} />;
};

export default ExpandAction;
